export default "__VITE_ASSET__a43da945__"